import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import M from "@/libs/mapping.js";

let dayjs = require("dayjs");

Vue.use(Vuex);

/**
 * store
 */
export default new Vuex.Store({
  state: {
    mode: null,
    accessToken: null,
    refreshToken: null,
    mallId: null,
    mallName: null,
    appCode: null,
    entries: null,
    pointBalance: 0,
  },
  mutations: {
    SET_ENTRIES(state, entires) {
      state.entries = entires;
    },
    SET_APP_CODE(state, app_code) {
      state.appCode = app_code;
    },
    SET_MALL_ID(state, mall_id) {
      state.mallId = mall_id;
    },
    SET_MALL_NAME(state, mall_name) {
      state.mallName = mall_name;
    },
    /**
     * 토큰 저장
     * @param {*} state
     * @param {*} accessToken
     */
    REFRESH_ACCESS_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
      // 토큰을 로컬 스토리지에 저장
      localStorage.setItem(`${state.mallId}_accessToken`, accessToken);
    },
    CHANGE_VERSION(state, version) {
      state.mode = version;
    },
    SET_VERSION(state, payload) {
      if (payload == "disable") {
        state.mode = "disable";
      } else {
        state.mode = payload;
      }
    },
    SET_POINT_BALANCE(state, point_balance) {
      state.pointBalance = point_balance;
    },
  },
  actions: {
    SET_ACCESS_TOKEN({ commit }, data) {
      commit("REFRESH_ACCESS_TOKEN", data.access_token);
      axios.defaults.headers.common["Authorization"] = data.access_token;
    },
    /**
     * 토큰인증 refresh
     * @param {*} param0
     */
    async REFRESH_ACCESS_TOKEN({ commit }) {
      let data = await M.api(M.entry("/auth/refresh"));

      if (data.access_token) {
        commit("REFRESH_ACCESS_TOKEN", data.access_token);
        axios.defaults.headers.common["Authorization"] = data.access_token;
      }
    },
    CHANGE_VERSION({ commit }, version) {
      if (version) {
        commit("CHANGE_VERSION", version);
      }
    },
    async SET_VERSION({ commit }) {
      try {
        let data = await M.api(M.entry("/get/mileage/usage"));

        if (Object.prototype.hasOwnProperty.call(data, "expires_at")) {
          const today = dayjs();
          const expires_at = dayjs(data.expires_at);
          let diff_day = expires_at.diff(today, "day", true);
          if (isNaN(diff_day) === false && diff_day > 0) {
            commit("SET_VERSION", "enabled");
          } else {
            commit("SET_VERSION", "disabled");
          }
        }
      } catch (e) {
        commit("SET_VERSION", "disabled");
      }
    },
  },
  getters: {},
});
